const VAPID_PUBLIC_KEY = "BB3MFMgYKO4JglRlKiC8sbnFG3m7Fb0DhoOB-mIAOdCLGIKhBbVk1JgBSlA90DTVofOh5MgKyfxmeDMwhDMISHc"

// Mensagem legível por trás de cada `motivo` que registrarPush() devolve -
// usado na tela de diagnóstico (DiagnosticoPush) pra alguém sem acesso ao
// console do celular conseguir entender o que travou.
export const MOTIVOS_FALHA_PUSH = {
  sem_suporte: "Este navegador não tem suporte a notificações push aqui (no iPhone, só funciona se o app foi instalado pela tela de início, não direto no Safari).",
  erro_permissao: "Deu erro ao pedir permissão de notificação ao sistema.",
  permissao_negada: "A permissão de notificação foi negada (ou já tinha sido negada antes). É preciso liberar notificações pra este site/app nas configurações do aparelho.",
  sw_nao_pronto: "O service worker (processo em segundo plano do app) não ficou pronto a tempo.",
  erro_subscribe: "Falha ao criar a inscrição de push junto ao navegador/sistema.",
  servidor_recusou: "O servidor recusou o registro do dispositivo.",
  erro_rede: "Erro de rede/servidor ao enviar o registro - conferir conexão com a internet.",
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
  const rawData = window.atob(base64)
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)))
}

// Registra (ou reconfirma) o push do dispositivo atual pro colaborador logado.
// Idempotente - o backend faz upsert por tipfun+codfun (ver PostDispositivo/
// srvPortal), então chamar de novo sempre que o app abre é seguro e barato.
// Cada etapa loga o motivo específico de falha (pedido do usuário, 2026-09-25:
// "precisamos ver o porquê" alguns celulares não gravam) - antes isso tudo
// falhava em silêncio, sem log nenhum, sem chegar nem no console.
export async function registrarPush(codfun, tipfun, api) {
  const TAG = "[push]"

  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    // Caso clássico do iOS: Push API só existe dentro do PWA instalado ("Adicionar
    // à Tela de Início") - no Safari normal (aba de navegador) PushManager nem
    // existe, então isto aqui é o motivo mais provável de "instalou mas não
    // registrou" em iPhone que não usa o app via ícone na tela.
    console.warn(TAG, "navegador sem suporte a Service Worker/Push (comum no iOS fora do modo instalado/PWA)")
    return { ok: false, motivo: "sem_suporte" }
  }

  let permission
  try {
    permission = await Notification.requestPermission()
  } catch (err) {
    console.error(TAG, "erro ao solicitar permissão de notificação", err)
    return { ok: false, motivo: "erro_permissao", err }
  }

  if (permission !== "granted") {
    // "denied" cobre tanto quem recusou agora quanto quem já tinha recusado
    // antes (o browser nem chega a perguntar de novo, já responde "denied").
    console.warn(TAG, "permissão de notificação não concedida:", permission)
    return { ok: false, motivo: "permissao_negada" }
  }

  let registration
  try {
    registration = await navigator.serviceWorker.ready
  } catch (err) {
    console.error(TAG, "service worker não ficou pronto", err)
    return { ok: false, motivo: "sw_nao_pronto", err }
  }

  let subscription
  try {
    subscription = await registration.pushManager.getSubscription()
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      })
    }
  } catch (err) {
    console.error(TAG, "falha ao criar subscription de push", err)
    return { ok: false, motivo: "erro_subscribe", err }
  }

  try {
    const res = await api.post("/colaborador/push/register", {
      codfun,
      tipfun,
      ...subscription.toJSON(),
    })

    if (res.data?.result === "ERRO") {
      console.error(TAG, "servidor recusou o registro do dispositivo:", res.data.msg)
      return { ok: false, motivo: "servidor_recusou", msg: res.data.msg }
    }

    return { ok: true }
  } catch (err) {
    console.error(TAG, "erro de rede/servidor ao registrar dispositivo", err)
    return { ok: false, motivo: "erro_rede", err }
  }
}
